<form class="" [formGroup]="NeuroAppoinmentForm">
  <div class="row g-3 mb-3 align-items-end">
    <div class="col-md-6">
      <div class="form-floating my-2" id="nextNeuroDiv">
        <input type="date" class="form-control" id="nextNeuro" formControlName="nextNeuro" placeholder="Next Neuro Appointment" />
        <label for="nextNeuro">Next Neuro Appointment</label>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-check mb-4">
        <input class="form-check-input" type="checkbox" id="neuroPRN" formControlName="neuroPRN" />
        <label class="form-check-label" for="neuroPRN"> Neuro PRN </label>
      </div>
    </div>
  </div>

  <div class="row g-3 mb-3">
    <div class="col-md-4" *ngFor="let item of [1, 2, 3, 4, 5, 6]">
      <div class="form-floating" id="neuroFU{{ item }}Div">
        <input type="date" class="form-control" id="neuroFU{{ item }}" formControlName="neuroFU{{ item }}" placeholder="Neuro FU {{ item }}" />
        <label for="neuroFU{{ item }}">Neuro FU {{ item }}</label>
      </div>
    </div>
  </div>

  <hr class="my-4" />

  <div class="row align-items-end g-3 mb-3">
    <div class="col-md-4">
      <div class="form-floating" id="uemgDateDiv">
        <input type="date" class="form-control" id="uemgDate" placeholder="UEMG " formControlName="uemgDate" />
        <label for="uemgDate">UEMG </label>
      </div>
    </div>
    <div class="col-md-8">
      <div class="form-check mb-4">
        <input class="form-check-input" type="checkbox" id="noUpperEMG" formControlName="noUpperEMG" />
        <label class="form-check-label" for="noUpperEMG"> No Upper EMG </label>
      </div>
    </div>
  </div>
  <div class="row align-items-end g-3 mb-3">
    <div class="col-md-4">
      <div class="form-floating" id="lemgDateDiv">
        <input type="date" class="form-control" id="lemgDate" placeholder="LEMG " formControlName="lemgDate" />
        <label for="lemgDate">LEMG </label>
      </div>
    </div>
    <div class="col-md-8">
      <div class="form-check mb-4">
        <input class="form-check-input" type="checkbox" id="noLowerEMG" formControlName="noLowerEMG" />
        <label class="form-check-label" for="noLowerEMG"> No Lower EMG </label>
      </div>
    </div>
  </div>
</form>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Close</button>
  <button type="button" class="btn btn-primary" (click)="isData ? updateNeuroAppointment() : makeNeuroAppoinment()" [disabled]="patientData.isDischarged">
    {{ isData ? 'Update' : 'Create' }} Appointment
  </button>
</div>
